import { render, staticRenderFns } from "./NewBilling.vue?vue&type=template&id=81a53196&"
import script from "./NewBilling.vue?vue&type=script&lang=js&"
export * from "./NewBilling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports